/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React, { useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import { ThemeProvider } from '@material-ui/core/styles';

import theme from 'styles/theme';
import { GlobalStyle } from 'styles/global-styles';
import '../styles/all.scss';

import { Routes } from './routes';

export function App() {
  const notistackRef = useRef<any>(null);

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={3}
        ref={notistackRef}
        action={key => (
          <span
            style={{ cursor: 'pointer', marginRight: 8 }}
            onClick={() =>
              notistackRef.current && notistackRef.current.closeSnackbar(key)
            }
          >
            X
          </span>
        )}
      >
        <BrowserRouter>
          <Helmet
            titleTemplate="%s - Nas.io | Empowering Education using Web3/Blockchain technology"
            defaultTitle="Nas.io | Empowering Education using Web3/Blockchain technology"
          >
            <meta
              name="description"
              content="Empowering Education using Web3/Blockchain technology.  We are the technology arm of Nas Academy, whose mission is to create the world's best learning communities."
            />
          </Helmet>
          <Routes />
          <GlobalStyle />
        </BrowserRouter>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
